import Repository from '../services/Repository'

export default class Exam {
    constructor(
        course,
        currentQuestion = null,
        questions = [],
        answers = {},
        finished = false
    ) {
        this.currentQuestion = currentQuestion;
        this.questions = questions;
        this.answers = answers;
        this.finished = finished;
        this.course = course
    }

    save() {
        Repository.saveExam(this.course.id, this.toJson())
    }

    isFinished() {
        return this.finished;
    }

    calculateTotalCorrectAnswers() {
        let total = 0;

        for (let question of this.questions) {
            const answerId = this.answers[question.id];

            if (!answerId) {
                continue;
            }

            let answer = question.answers.filter((answer) => answer.id == answerId)[0];

            if (!answer) {
                continue;
            }

            if (answer.isCorrect) {
                total = total + 1;
            }
        }

        return total;
    }

    toJson() {
        return JSON.stringify({
            currentQuestion: this.currentQuestion,
            questions: this.questions,
            answers: this.answers,
            finished: this.finished,
        })
    }
}